function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { LabelStyle } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export { LabelSubtitle } from './styles';

var Label = function Label(_ref) {
  var children = _ref.children,
      id = _ref.id,
      hideLabel = _ref.hideLabel,
      hasError = _ref.hasError,
      onClick = _ref.onClick,
      labelDirection = _ref.labelDirection,
      props = _objectWithoutProperties(_ref, ["children", "id", "hideLabel", "hasError", "onClick", "labelDirection"]);

  if (hideLabel) {
    return null;
  }

  return ___EmotionJSX(LabelStyle, _extends({
    htmlFor: id,
    className: 'form-label',
    hasError: hasError,
    onClick: onClick,
    labelDirection: labelDirection
  }, props), children);
};

export default Label;